import type { EUserRole } from '@~/reducers/auth';

import { createActionWithPayload } from './utils';

export const ACTIONS = {
  SET_ACTIVE_USER_TYPE: 'SET_ACTIVE_USER_TYPE',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  SET_REDIRECT_TO: 'SET_REDIRECT_TO',
} as const;

export const setActiveUserType = createActionWithPayload<
  typeof ACTIONS.SET_ACTIVE_USER_TYPE,
  {
    activeUserType: EUserRole | null;
  }
>(ACTIONS.SET_ACTIVE_USER_TYPE);

export const userLogInSuccess = createActionWithPayload<
  typeof ACTIONS.LOGIN_SUCCESS,
  {
    user_id: string;
    student_service_id?: string;
    loggedInAs?: EUserRole | null;
  }
>(ACTIONS.LOGIN_SUCCESS);

export const setredirectTo = createActionWithPayload<
  typeof ACTIONS.SET_REDIRECT_TO,
  {
    redirectTo: string | null;
  }
>(ACTIONS.SET_REDIRECT_TO);
